export interface Configuration {
    serviceEndpoint: string;
}

export function getConfiguration(): Configuration {
    switch (window.location.host) {
        case 'www.draugas.lt':
        case 'local.www.draugas.lt':
            return {
                serviceEndpoint: '//demopazintys.draugas.lt/',
            };
        default:
            return {
                serviceEndpoint: '',
            };
    }
}